(ns ui.components.radix-ui.accordion.view
  (:require
   [reagent.core :as r]
   [oops.core :as oops]
   ["@radix-ui/react-accordion" :as Accordion]))

(defn adapt
  [cls-name]
  (r/adapt-react-class (oops/oget+ Accordion cls-name)))

(def accordion-root (adapt "Root"))
(def accordion-item (adapt "Item"))
(def accordion-header (adapt "Header"))
(def accordion-trigger (adapt "Trigger"))
(def accordion-content (adapt "Content"))

(def accordion-primitive-root (adapt "Root"))
(def accordion-primitive-trigger (adapt "Trigger"))
(def accordion-primitive-content (adapt "Content"))
(def accordion-primitive-item (adapt "Item"))
(def accordion-primitive-header (adapt "Header"))
